module.exports = JSON.parse("{\"timestamp\":\"20.09.2026 - 11:50:57\",\"brands\":[]}")